export const phoneNum = {
  label: "+1-800-265-0080",
  value: "+18002650080",
};